<template>
  <div>
    <div class=" pc">
      <el-scrollbar style="height:100vh;" >
        <div class="user-img">
          <img  src="@/assets/white.png">
        </div>
        <el-menu
            :default-active="path"
            class="left-item"
            @select="GetIndex"
            background-color="#202B3D"
            text-color="#fff"
            @open="handleOpen"
            active-text-color="#ffd04b">
          <el-menu-item index="/user/menu">
            <template slot="title">
              <i class="el-icon-s-operation"></i>
              <span>菜单管理</span>
            </template>
          </el-menu-item>
          <el-submenu index="/user/pic">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>图片信息</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/user/pic">分类管理</el-menu-item>
              <el-menu-item index="/user/pic_info">图片信息</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/user/quality">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>首页管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/user/service_concept">服务项目</el-menu-item>
              <el-menu-item index="/user/quality">资质信誉</el-menu-item>
              <el-menu-item index="/user/news">案例与新闻</el-menu-item>
              <el-menu-item index="/user/partner">合作伙伴</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/user/manage">
            <template slot="title">
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/user/supply">
            <template slot="title">
              <img src="~assets/image/supply.png" alt="" style="width: 18px;height: 18px;margin-right: 8px;margin-left: 3px">
              <span>供应商</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/user/company">
            <template slot="title">
              <img src="~assets/image/info.png" alt="" style="width: 18px;height: 18px;margin-right: 8px;margin-left: 2px">
              <span>公司介绍</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/user/recruitment">
            <template slot="title">
              <img src="~assets/image/recruit.png" alt="" style="width: 19px;height: 19px;margin-right: 8px;margin-left: 2px">
              <span>公司招聘</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/user/service">
            <template slot="title">
              <i class="el-icon-service"></i>
              <span>售后服务</span>
            </template>
          </el-menu-item>
          <el-menu-item index="/user/develop">
            <template slot="title">
              <img src="~assets/image/trend.png" alt="" style="width: 20px;height: 20px;margin-right: 9px">
              <span>发展历程</span>
            </template>
          </el-menu-item>
          <el-submenu index="/user/sign">
            <template slot="title">
              <i class="el-icon-tickets"></i>
              <span>标签管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/user/sign">产品标签</el-menu-item>
              <el-menu-item index="/user/classify">产品所属分类</el-menu-item>
              <el-menu-item index="/user/tag">标签</el-menu-item>
              <el-menu-item index="/user/product_info">产品信息</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/user/land">
            <template slot="title">
              <i class="el-icon-baseball"></i>
              <span>瑞普乐园</span>
            </template>
          </el-menu-item>
        </el-menu>
      </el-scrollbar>
    </div>
    <div class="ipad">
      <el-scrollbar style="height:100vh;" >
        <div class="user-img">
          <img  src="@/assets/logo.png">
        </div>
        <el-menu
            collapse
            class="left-item"
            @select="GetIndex"
            :default-active="path"
            background-color="#202B3D"
            text-color="#fff"
            @open="handleOpen"
            active-text-color="#ffd04b">
          <el-menu-item index="/user/menu">
            <i class="el-icon-s-operation"></i>
            <span slot="title">菜单管理</span>
          </el-menu-item>
          <el-submenu index="/user/pic">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>图片信息</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/user/pic">分类管理</el-menu-item>
              <el-menu-item index="/user/pic_info">图片信息</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/user/quality">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>首页管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/user/service_concept">服务项目</el-menu-item>
              <el-menu-item index="/user/quality">资质信誉</el-menu-item>
              <el-menu-item index="/user/news">案例与新闻</el-menu-item>
              <el-menu-item index="/user/partner">合作伙伴</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/user/manage">
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/user/supply">
            <img src="~assets/image/supply.png" alt="" style="width: 18px;height: 18px;margin-right: 8px;margin-left: 3px">
            <span slot="title">供应商</span>
          </el-menu-item>
          <el-menu-item index="/user/company">
            <img src="~assets/image/info.png" alt="" style="width: 18px;height: 18px;margin-right: 8px;margin-left: 2px">
            <span slot="title">公司介绍</span>
          </el-menu-item>
          <el-menu-item index="/user/recruitment">
            <img src="~assets/image/recruit.png" alt="" style="width: 19px;height: 19px;margin-right: 8px;margin-left: 2px">
            <span slot="title">公司招聘</span>
          </el-menu-item>
          <el-menu-item index="/user/service">
            <i class="el-icon-service"></i>
            <span slot="title">售后服务</span>
          </el-menu-item>
          <el-menu-item index="/user/develop">
              <img src="~assets/image/trend.png" alt="" style="width: 20px;height: 20px;margin-right: 9px">
              <span slot="title">发展历程</span>
          </el-menu-item>
          <el-submenu index="/user/sign">
            <template slot="title">
              <i class="el-icon-tickets"></i>
              <span>标签管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/user/sign">产品标签</el-menu-item>
              <el-menu-item index="/user/classify">产品所属分类</el-menu-item>
              <el-menu-item index="/user/tag">标签</el-menu-item>
              <el-menu-item index="/user/product_info">产品信息</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index="/user/land">
              <i class="el-icon-baseball"></i>
              <span slot="title">瑞普乐园</span>
          </el-menu-item>
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>

export default {
  name: "NavMenu",
  data(){
    return{
      Index:1,
    }
  },
  computed:{
    path() {
      return this.$route.path.replace('/base','')
    }
  },
  methods:{
    handleOpen(key, keyPath) {
      this.$router.push(key)
    },
    GetIndex(index){
      this.$router.push(index)
    }
  }

}
</script>

<style lang="less" >
@media screen and (min-width: 1000px){
  .pc {
    display: block;
  }
  .ipad{
    display: none;
  }
}
@media screen and (max-width: 1000px){
  .pc {
    display: none;
  }
  .ipad{
    display: block;
  }
}
.pc{
  width: 10vw;
  background-color:#202B3D;
  //overflow-x: scroll;
  .user-img{
    img{
      height: auto;
      object-fit: cover;
    }
  }
  .el-menu {
    width: 100%;
    overflow: hidden;
    border-right: none;
  }
}
.ipad{

  background-color:#202B3D;
  //overflow-x: scroll;
  .user-img{

    img{
      height: auto;
      object-fit: cover;
    }
  }
  .el-menu {
    width: 100%;
    overflow: hidden;
    border-right: none;
  }
}
</style>